module.exports = "pegasus/assets/blocks/column-lp11-basic.png";